import { render, staticRenderFns } from "./mortgageCreate.vue?vue&type=template&id=fcf523a4&scoped=true&lang=html&"
import script from "./mortgageCreate.vue?vue&type=script&lang=js&"
export * from "./mortgageCreate.vue?vue&type=script&lang=js&"
import style0 from "./mortgageCreate.vue?vue&type=style&index=0&id=fcf523a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf523a4",
  null
  
)

export default component.exports